import FrenchPage from '../components/lifecycle/FrenchPage';
import LocationHeadFR from '../components/location/LocationHeadFR';
import Location from './Location';

export default function LocationFR() {
  return (
    <>
      <FrenchPage />
      <LocationHeadFR />
      <Location />
    </>
  );
}